import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prompt-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "prompt-description" }

import Prompt from '@/types/Prompt'


export default /*@__PURE__*/_defineComponent({
  __name: 'PromptCard',
  props: {
    prompt: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

function handleClick() {
  emit('select', props.prompt)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: props.prompt.image_url,
      onClick: handleClick,
      alt: "prompt image",
      class: "prompt-image"
    }, null, 8, _hoisted_2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(props.prompt.prompt), 1)
  ]))
}
}

})